import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Notification {
    id: number;
    status?: string;
    [key: string]: any;
}

interface NotificationsState {
    items: Notification[];
    loading: boolean;
    initialLoading: boolean;
    allLoaded: boolean;
    currentPage: number;
}

const initialState: NotificationsState = {
    items: [],
    loading: false,
    initialLoading: true,
    allLoaded: false,
    currentPage: 1,
};

const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        setNotifications(state, action: PayloadAction<Notification[]>) {
            state.items = action.payload;
        },
        addNotifications(state, action: PayloadAction<Notification[]>) {
            const newNotifications = [...state.items];
            action.payload.forEach((notify) => {
                const notifyIndex = newNotifications.findIndex((row) => row.id === notify.id);
                if (notifyIndex === -1) {
                    newNotifications.push(notify);
                }
            });
            state.items = newNotifications;
        },
        updateNotificationStatus(state, action: PayloadAction<{ id: number; status: string }>) {
            const notificationIndex = state.items.findIndex((row) => row.id === action.payload.id);
            if (notificationIndex !== -1) {
                state.items[notificationIndex].status = action.payload.status;
            }
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setInitialLoading(state, action: PayloadAction<boolean>) {
            state.initialLoading = action.payload;
        },
        setAllLoaded(state, action: PayloadAction<boolean>) {
            state.allLoaded = action.payload;
        },
        setCurrentPage(state, action: PayloadAction<number>) {
            state.currentPage = action.payload;
        },
        incrementPage(state) {
            state.currentPage += 1;
        },
        clearNotifications(state) {
            state.items = [];
            state.currentPage = 1;
            state.allLoaded = false;
            state.initialLoading = true;
        },
    },
});

export const {
    setNotifications,
    addNotifications,
    updateNotificationStatus,
    setLoading,
    setInitialLoading,
    setAllLoaded,
    setCurrentPage,
    incrementPage,
    clearNotifications,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
